let totalDropdown = () => {
    return {
        init() {
            let url = window.location.href;
            let homeLink = document.querySelector(".total-dropdown-header .home-link");

            if (homeLink) {
                let aTag = document.querySelector(".total-dropdown-header .home-link a");

                if (aTag.href === url) {
                    homeLink.classList.add("active");
                }
            }
        },
        open: false,
        handleOpen(e) {
            e.preventDefault();
            this.open = !this.open;
            this.open ? document.body.classList.add("nav-open") : document.body.classList.remove("nav-open");
        }
    };
};
export default totalDropdown;
